import React, { PropsWithChildren, useEffect, useState } from 'react'
import clsx from 'clsx'
import { useOutsideClick } from '../../../../../shared/lib/hooks/UseOutsideClick'
import { IconCrossBold } from '../../../../../shared/components/icons/IconCrossBold'
import { IconButton } from '../../../../../shared/components/buttons/icon-button/IconButton'

import styles from './Modal.module.scss'

export interface ModalProps extends PropsWithChildren {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'

  open?: boolean
  scroll?: boolean

  onClose?: () => void
}

export const Modal = ({ children, ...props }: ModalProps) => {
  const { size = 'md', open = false, scroll = false, onClose } = props

  const [isOpen, setIsOpen] = useState(open)
  const body = document.querySelector('body')
  const clickRef = useOutsideClick(() => {
    handleClose()
  })

  const handleClose = () => {
    setIsOpen(false)
    onClose?.()
  }

  useEffect(() => {
    if (body && isOpen) {
      body.style.overflow = 'hidden'
    } else if (body) {
      body.style.overflow = 'auto'
    }

    return () => {
      if (body) {
        body.style.overflow = 'auto'
      }
    }
  }, [isOpen])

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  if (!isOpen) return null

  return (
    <div className={clsx(styles.wrapper, styles[size], { [styles.scroll]: scroll })}>
      <div ref={clickRef} className={clsx(styles.content)}>
        <div className={clsx(styles.closeButton)}>
          <IconButton onClick={handleClose}>
            <IconCrossBold color='#6684A7' />
          </IconButton>
        </div>
        {children}
      </div>
    </div>
  )
}
